import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { simpleTransaction } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  simpleTransaction: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class SimpleTransaction extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SIMPLETRANSACTION_REPORT',
      path: ["Home", "Simple Transaction"],
      links: ["home", "report/simpletransaction"],
      date: new Date(),
      limit: 10,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      dealType: "",
      sales: [],
      isLoading: "false",
      csvData: "",
      offerIDs: "",
      transaction : "",
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    if(e.target.name == 'dealType'){
      this.props.getAllCategorys({categoryType: e.target.value, page:0});
      this.setState({catID: ''});
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      this.setState({ sales: "" });
      let formData = {
        page: 1,
        limit: this.state.limit,
        catID: this.state.catID,
        merchantTypeID: this.state.merchantTypeID,
        offerIDs: this.state.offerIDs,
        dealType: this.state.dealType,
      };

      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData.startDate = moment(dateRange[0]).format('YYYY-MM-DD');
        formData.endDate = moment(dateRange[1]).format('YYYY-MM-DD');
      } else {
        formData.startDate = moment(this.state.startDate).format('YYYY-MM-DD');
      }

      this.props.simpleTransaction(formData);
    }
  }

  Clear = () => {};

  handlePageChange = page => {
    this.setState({ sales: "", currentPage: page });

    let formData = {
      page: page,
      limit: this.state.limit,
      catID: this.state.catID,
      merchantTypeID: this.state.merchantTypeID,
      offerIDs: this.state.offerIDs,
      dealType: this.state.dealType,
    };

    if (this.state.range == true) {
      let dateRange = this.state.startDateRange;
      formData.startDate = moment(dateRange[0]).format('YYYY-MM-DD');
      formData.endDate = moment(dateRange[1]).format('YYYY-MM-DD');
    } else {
      formData.startDate = moment(this.state.startDate).format('YYYY-MM-DD');
    }

    this.props.simpleTransaction(formData);
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'})
        this.props.getAllCategorys({categoryType: 'offer', page:0});
      }else{
        this.props.getAllCategorys({categoryType: this.state.dealType, page:0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catData: nextProps.catData.data });
      }
    }

    if (this.props.transaction !== nextProps.transaction) {
      if (nextProps.transaction) {
        const transactionRecords = nextProps.transaction.data
        const setPageCount =
          transactionRecords.total / transactionRecords.per_page;
        this.setState({
          userList: transactionRecords.data,
          totalRecords: transactionRecords.total,
          perPage: transactionRecords.per_page,
          pageCount: setPageCount
        });
        
        isLoading = "false";
        this.setState({ transaction: nextProps.transaction.data.data });
        this.handleExport(nextProps.transaction.data.data);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        "Merchant ID",
        "Merchant Legal Name",
        "Proposal Type",
        "City",
        "Transaction Date",
        "Adjusted Gross",
        "Net To Site",
        "Sales Rep Full Name",
        "Sales Rep Email",
      ]
    ];
    {data &&
      data.map((tran, index) =>
        csvData.push([
          tran.merchant_id,
          tran.legalName,
          tran.proposal_type,
          tran.city_name,
          tran.transaction_date,
          tran.adjusted_gross_sale,
          tran.net_to_site,
          tran.sales_representative_fullname,
          tran.sales_representative_email
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Simple Transaction</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                    >
                    <option value="">All</option>
                    <option value="offer">Offer</option>
                    <option value="products">Products</option>
                    <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="offerIDs">
                    <ControlLabel>Deal IDs(separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.offerIDs}
                      placeholder="Deal ID"
                      onChange={this.handleChange}
                      name="offerIDs"
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="proposalType">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.merchantTypeIDError }}
                      name="merchantTypeID"
                      onChange={this.handleChange}
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.merchantType) &&
                        this.state.merchantType.map((type, index) => (
                          <option
                            key={type.merchantTypeID}
                            value={type.merchantTypeID}
                          >
                            {type.merchantTypeName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>

                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"transaction-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Merchant ID</th>
                  <th>Merchant Legal Name</th>
                  <th>Proposal Type</th>
                  <th>City</th>
                  <th>Transaction Date</th>
                  <th>Adjusted Gross</th>
                  <th>Net To Site</th>
                  <th>Sales Rep Full Name</th>
                  <th>Sales Rep Email</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.transaction) ? (
                  this.state.transaction.map((tran, index) => (
                    <tr key={Math.random()+index}>
                      <td>{++index}</td>
                      <td>{tran.merchant_id}</td>
                      <td>{tran.legalName}</td>
                      <td>{tran.proposal_type}</td>
                      <td>{tran.city_name}</td>
                      <td>{tran.transaction_date}</td>
                      <td>{tran.adjusted_gross_sale}</td>
                      <td>{tran.net_to_site}</td>
                      <td>{tran.sales_representative_fullname}</td>
                      <td>{tran.sales_representative_email}</td>
                    </tr>
                  ))
                ) : (
                  <tr key={Math.random()}>
                    <td colSpan="68">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="text-center">
              <Pagination
                total={totalRecords}
                limit={perPage}
                pageCount={5}
                currentPage={currentPage}
              >
                {({
                  pages,
                  currentPage,
                  hasNextPage,
                  hasPreviousPage,
                  previousPage,
                  nextPage,
                  totalPages,
                  getPageItemProps
                }) => (
                  <div className="pagination">
                    <button className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: 1,
                        onPageChange: this.handlePageChange
                      })}
                    >
                      first
                    </button>

                    {hasPreviousPage && (
                      <button className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: previousPage,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        {"<"}
                      </button>
                    )}

                    {pages.map(page => {
                      let activePage = null;
                      if (currentPage === page) {
                        activePage = {
                          backgroundColor: "#ccc",
                          color: "#666"
                        };
                      }
                      return (
                        <button className="btn btn-default"
                          key={page}
                          style={activePage}
                          {...getPageItemProps({
                            pageValue: page,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {page}
                        </button>
                      );
                    })}

                    {hasNextPage && (
                      <button className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: nextPage,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        {">"}
                      </button>
                    )}

                    <button className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: totalPages,
                        onPageChange: this.handlePageChange
                      })}
                    >
                      last
                    </button>
                  </div>
                )}
              </Pagination>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    transaction: state.reportReducer.transaction
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    simpleTransaction
  })
)(SimpleTransaction);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/SimpleTransaction.js